export default __webpack_public_path__ + "static/media/611.39d98a62.gif";